import React from "react";
import { goTo } from "../tools";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';

const error3Posiciones = "Debe ser minimo de 2 posiciones.";
const mensajeError = "Este campo sólo acepta letras.";
const msjVacio = "Campo requerido";

const ABC = "abcdefghijklmnopqrstuvwxyz";
const NUMEROS = "0123456789";
const ZYX = "zyxwvutsrqponmlkjihgfedcba";
const msjConsecutivo = "Verifica el nombre ingresado. No se aceptan caracteres consecutivos iguales";
let error = false;

const style1 = {
	marginLeft: "-13px",
	width: "77%"
}

const style2 = {
	marginLeft: "-146px",
	width: "77%"
}

const mapState = (state) => {
	let fechaNacimiento = "";
	if (state.registro.fechaNacimiento === "") {
		fechaNacimiento = state.registro.fechaDeNacimiento;
	} else {
		fechaNacimiento = state.registro.fechaNacimiento;
	}

	return {
		initialValues: {
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres,
			email: state.registro.email,
			fechaNacimiento: fechaNacimiento,
			ramo: state.registro.ramo,
			poliza: state.registro.poliza
		},
		email: state.registro.email,
		fechaNacimiento: fechaNacimiento,
		ramo: state.registro.ramo,
		poliza: state.registro.poliza,
		certificado: state.registro.certificado,
		inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const campo = ({ input, label, max, type,id, focus, change, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				onFocus={focus}
				onChange={(event) => { input.onChange(event) }}
				maxLength={max}
				errorText={touched && error}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				id={id}
			/>
		</MuiThemeProvider>
	);
};

const campoEmail = ({ input, value, type }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						console.log("campoEmail");
					}
				}}
				fullWidth={true}
				hintText="Correo electrónico"
				floatingLabelText="Correo electrónico"
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				disabled={true}
				defaultValue={value}
			/>
		</MuiThemeProvider>
	);
};

const campoFecha = ({ input, value, type }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				fullWidth={true}
				hintText="Fecha de nacimiento"
				floatingLabelText="Fecha de nacimiento"
				defaultValue={value}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						console.log("campoFecha");
					}
				}}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				disabled={true}
			/>
		</MuiThemeProvider>
	);
};

const campoRamo = ({ input, value, type }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						console.log("campo ramo");
					}
				}}
				type={type}
				disabled={true}
				defaultValue={value}
				fullWidth={true}
				hintText="Ramo"
				floatingLabelText="Ramo"
			/>
		</MuiThemeProvider>
	);
};

const campoPoliza = ({ input, value, type }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				type={type}
				disabled={true}
				defaultValue={value}
				fullWidth={true}
				hintText="No. de póliza o de referencia"
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						console.log("campo poliza");
					}
				}}
				floatingLabelText="No. de póliza o de referencia"
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
			/>
		</MuiThemeProvider>
	);
};

const handleKeyPress = (input) => {
	const inputs = document.getElementsByTagName('input');
	const inputActual = input.name;
	for (let index = 0; index < inputs.length; index++) {
		if (inputActual === inputs[index].name) {

			switch (input.name) {
				case "amaterno":
					console.log("amaterno");
					document.getElementById(inputs[index].id).blur();
					break;
				case "nombres":
					console.log("nombres");
					document.getElementById(inputs[index + 1].id).focus();
					break;
				case "apaterno":
					console.log("apaterno");
					document.getElementById(inputs[index + 1].id).focus();
					break;
				default:
					break;
			}
		}
	}
}

const validate = values => {
	const errors = {};

	validacionNombre(values, errors);
	validacionApPaterno(values, errors);
	return errors;
}

const validacionNombre = (values, errors) => {
	if (values.nombres === "" || values.nombres === undefined) {
		errors.nombres = msjVacio;
		error = true;
	} else if ((values.nombres).length > 0 && (values.nombres).length < 2) {

		errors.nombres = error3Posiciones;
		error = true;
	}else if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/g.test(values.nombres)) {

		errors.nombres = mensajeError;
		error = true;
	}  else {
		error = false;
	}
}

const validacionApPaterno = (values, errors) => {
	if (values.apaterno === "" || values.apaterno === undefined) {
		errors.apaterno = msjVacio;
		error = true;
	} else if ((values.apaterno).length > 0 && (values.apaterno).length < 2) {

		errors.apaterno = error3Posiciones;
		error = true;
	}else if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/g.test(values.apaterno)) {

		errors.apaterno = mensajeError;
		error = true;
	}  else {
		error = false;
	}
}

const validacionApMaterno = (values, errors) => {
	if (values.amaterno === "" || values.amaterno === undefined) {
		errors.amaterno = msjVacio;
		error = true;
	} else if ((values.amaterno).length > 0 && (values.amaterno).length < 2) {

		errors.amaterno = error3Posiciones;
		error = true;
	}else if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/g.test(values.amaterno)) {

		errors.amaterno = mensajeError;
		error = true;
	}  else {
		error = false;
	}
}

const campoSettings = {
	fontFamily: 'Open Sans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#FF6B0B',
}

class CompletarForm extends React.Component {
	errorsNombres = false;
	errorsApaterno = false;
	errorsApmaterno = false


	state = {
		ramo: "Gastos Medicos",
		habilitarBoton: true,
		desactivado: true,
	}

	componentWillMount = () => {

		if (this.props.ramo === "G" || this.state.ramo === "G") {
			this.props.change("ramo", 'Gastos Médicos');
		} else if (this.props.ramo === "D" || this.state.ramo === "D") {
			this.props.change("ramo", 'Daños');
		} else if (this.props.ramo === "V" || this.state.ramo === "V") {
			this.props.change("ramo", 'Vida');
		} else if (this.props.ramo === "A" || this.state.ramo === "A") {
			this.props.change("ramo", 'Autos');
		} else {
			console.log('no es ningun ramo')
		}
			
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro-asistido")) {
			main.style.maxHeight = "100%";
			main.style.paddingBottom = "30px";
			main.style.overflow = "hidden auto";
		}

		var nombres = document.getElementById("nombres");
		var apaterno = document.getElementById("apaterno");
		var amaterno = document.getElementById("amaterno");
		
		function hendler() {
			nombres.value = nombres.value.trim();
			apaterno.value = apaterno.value.trim();
			amaterno.value = amaterno.value.trim();
		}
		nombres.addEventListener('blur', hendler,false);
		apaterno.addEventListener('blur', hendler,false);
		amaterno.addEventListener('blur', hendler,false);
	
	}

	regresar = () => {
		this.props.tagManager({
			"type": "EVENT_REGISTRO_REGRESAR_ASISTIDO",
			"dispositivo": this.props.dispositivo
		});
		localStorage.setItem("correo", "true");
		goTo("gnp/registro");

	}



	whatIWantToRunOnSubmit = (values) => {
		
		if (values.nombres !== "" || values.apaterno !== "" || values.amaterno !== "") {
			this.props.onSubmit({ ...values });
		}
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit(this.whatIWantToRunOnSubmit)}>
				<div id="div-gral-return">
					<div className="div-return">
						<div className="flecha-naranja">
							<span className="material-icons bi bi-arrow-left" onClick={this.regresar}>arrow_back</span>
						</div>
						<div className="regresar">
							<label className="btn-return" onClick={this.regresar}>Regresar</label>
						</div>
						<div className="titulo1">
							<label className="txt-1">Ingresa la información solicitada</label>
						</div>
					</div>

					<label className="txt-3">Para poder concluir tu registro es importante que nos proporciones tu siguiente información:</label><br />
				</div>

				<div className="datos-wrap mt-10" id="datos-wrap" style={{ marginTop: "-30px" }}>
					<div className="row" style={{ marginTop: "-8px" }}>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style1}>
								<div className="col-xs-12" id="datosStilosANombres">
									<Field name="nombres" id="nombres" label="Nombre(s)" component={campo} type="text" />
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style2}>
								<div className="col-xs-12" id="datosStilosAPaterno">
									<Field name="apaterno" id="apaterno" label="Apellido Paterno" component={campo} type="text" />
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style1}>
								<div className="col-xs-12" id="datosStilosAMaterno">
									<Field name="amaterno" id="amaterno" label="Apellido Materno" component={campo} type="text"/>
								</div>
							</div>
						</div>
					</div>

					<label className="txt-3" id="textoRespo">Agradecemos que valides tu información, si es correcta puedes continuar.</label>

					<div className="row" style={{ marginTop: "-40px" }}>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style1}>
								<div className="col-xs-12" id="datosStilosAemail">
									<Field name="email" defaultValue={this.props.email} component={campoEmail} type="input" />
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style2}>
								<div className="col-xs-12" id="datosStilosANacimiento">
									<Field name="fechaNacimiento" defaultValue={this.props.fechaNacimiento} component={campoFecha} type="date" />
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style1}>
								<div className="col-xs-12" id="datosStilosARamo">
									<Field name="ramo" component={campoRamo} type="input" defaultValue={this.props.ramo} />
								</div>
							</div>
						</div>

						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={style2}>
								<div className="col-xs-12" id="datosStilosAPoliza">
									<Field name="poliza" defaultValue={this.props.poliza} component={campoPoliza} type="input" />
								</div>
							</div>
						</div>
					</div>

				</div>

				<div className="datos-wrap" id="div-continuar-asistido">
					<div className="row btn-bottom">
						<div className="col-md-6 col-sm-6 col-xs-12">
							<button className="orange-rectangle" id="btn-continuar-asistido" type="submit">Continuar</button>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

CompletarForm = reduxForm({ form: "registro-asistido-completar", validate })(CompletarForm);
export default connect(mapState, mapDispatch)(CompletarForm);



// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/completar.frm.js